import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'xsI18nDate'
})
export class XsI18nDatePipe implements PipeTransform {

  transform(date: any, format: any): any {
    return moment(date).local().format(format);
  }

}
